<template>
  <div>
    <!--签约平台-->
    <el-form size="small" label-width="200px" v-show="showPickPayType">
      <!--超级管理员信息-->
      <div class="common-form">签约平台</div>
      <el-form-item label="平台名称" prop="payType">
        <el-radio-group v-model="payType" class="beautiful-check" @input="payTypeChange">
          <el-radio border :label="20">
            <img src="../../../assets/pay/wepay.png" alt="wepay"><h4>微信支付</h4>
          </el-radio>
          <el-radio border :label="30">
            <img src="../../../assets/pay/alipay.png" alt="alipay"><h4>支付宝</h4>
          </el-radio>
          <el-radio border :label="40">
            <img src="../../../assets/pay/lakala.png" alt="lakala"><h4>拉卡拉</h4>
          </el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <!--微信-->
    <Wepay v-if="payType === 20 && !showPickPayType" :payInfo=payInfo></Wepay>
    <!--支付宝-->
    <Alipay v-else-if="payType === 30 && !showPickPayType" :payInfo=payInfo></Alipay>
    <!--拉卡拉-->
    <Lakala v-else-if="payType === 40 && !showPickPayType" :payInfo=payInfo></Lakala>

    <div class="poster_footer" v-show="showPickPayType">
      <el-button type="primary" @click="okClick">确定</el-button>
    </div>
  </div>

</template>

<script>
import Wepay from './part/Wepay.vue';
import Lakala from './part/Lakala.vue';
import Alipay from './part/Alipay.vue';
import moment from 'moment'

export default {
  computed: {
    payInfo() {
      return {timeStamp: moment().unix(),  op: this.$route.query.op};
    },
  },
  components: {
    Wepay,
    Lakala,
    Alipay,
  },
  data() {
    return {
      loading: false,
      showPickPayType: true,
      payType: 20
    };
  },
  created() {
  },
  watch: {},
  mounted() {

  },
  methods: {
    payTypeChange(e) {
      let self = this;
    },
    okClick(e) {
      let self = this;
      self.showPickPayType = false;
    },
  }
};
</script>

<style lang="scss" scoped>

.poster_footer {
  display: flex;
  justify-content: center;
  margin: 24px;
}

.beautiful-check {
  .el-radio-button__inner {
    position: relative;
    min-width: 80px;
    padding: 0 20px;
    line-height: 34px;
    box-sizing: content-box;
  }

  .ant-checkbox .ant-checkbox-inner {
    display: none;
  }

  .el-radio.is-bordered.is-checked {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MzlGOUFGRjhBN0Q2MTFFNkFFOURCNzQ1MzE4QjYxRTEiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MzlGOUFGRjlBN0Q2MTFFNkFFOURCNzQ1MzE4QjYxRTEiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDozOUY5QUZGNkE3RDYxMUU2QUU5REI3NDUzMThCNjFFMSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDozOUY5QUZGN0E3RDYxMUU2QUU5REI3NDUzMThCNjFFMSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PuxVFZcAAAFDSURBVHjaYmQ4NJ+BBqCeiRaGAnEDEy0MBTGYaGEoNQ1GMZRaBmMYSg2DsRpKqcE4DaXEYLyGkmTwf9sEMCbGUJJdzHh4AVGGggALNQ3lZ2Fj2KXjxvD7/z+iXUzQUGZGRoYl6rYMZrwiDJxMzEQZTJT3OxVMGHyEZBle//7BEH7jIEGDMQw9rO/JcNrQh0GUlQMuliyhylAso83wCxgEodcPMNz5/gmvwVhdysnEwmDCI8KwX88DbLg9vwTDNBVLsFzm7eMMBz++gMQJjvIYp/fFgIbtAxqqzSXAcO3bB7DhINz75CpDyf3TeJMb3jB9BQxDp0s7GK4CDdUCGg4ydMu7xwzlD87gTcdERRSy4Ze/vmeIuXmY4e///zjTMdGJH2a4I9BwXmZWho9/fuHMICQZCgOgpAXCuLI0WYYSAgABBgDNlm9xwnxZXgAAAABJRU5ErkJggg==) 100% 100% no-repeat;
    border-color: #00c29f;
  }

  .ant-checkbox-wrapper {
    margin-right: 10px;
    text-align: center;
  }

  .el-radio {
    top: 0;
    left: 0;
    width: 204px;
    height: 204px;
    border: 1px solid #cdd9e6;
    border-radius: 3px;
    background: #fbfcfd;
    text-align: center;

    img {
      margin: 40px auto 25px;
      width: 80px;
      height: 80px;
    }

    h4 {
      font-size: 18px;
      color: #1f2d3d;
      font-weight: 400;
      margin: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/setting/applyment/add.vue